export const extractStatisticsConfiguration = (observationType) => {
    const statisticsConfiguration = observationType.visualisers.filter((visualiser) => visualiser.type === 'statistical')[0];
    if (statisticsConfiguration) {
        const callbacksMap = observationType.callbacks
            ? observationType.callbacks.reduce((map, callback) => {
                map[callback.processor] = callback;
                return map;
            }, {})
            : {};
        parseStatisticsConfiguration(statisticsConfiguration, callbacksMap, observationType);
    }
    return statisticsConfiguration;
};
const parseStatisticsConfiguration = (configuration, callbacksMap, observationType) => {
    // preprocess options for an easier experience later
    // pre-process charts and add charCount property for each section
    configuration.options.sections.forEach((section) => {
        // add charCount property for each section
        section.chartCount = section.charts
            .map((chart) => chart.charts !== undefined
            ? chart.charts.length
            : 1)
            .reduce((total, count) => total + count, 0);
        //pre-process all (sub-)charts
        section.charts.forEach((chart) => {
            if (chart.type === 'pie') {
                let pieChart = chart;
                enrichChart(observationType, callbacksMap, pieChart, pieChart.propertyName);
            }
            else if (chart.type === 'filteredPie') {
                let filteredPieChart = chart;
                enrichChart(observationType, callbacksMap, filteredPieChart, filteredPieChart.filterBy);
                filteredPieChart.isMultiValueFilter =
                    filteredPieChart.filterValue !== undefined &&
                        filteredPieChart.filterValue.push !== undefined;
                filteredPieChart.isFixedFilter =
                    filteredPieChart.filterValue !== undefined && filteredPieChart.filterValue.length > 0;
                // enrich sub charts and concatenate these labels to
                filteredPieChart.charts.forEach((subChart) => {
                    enrichChart(observationType, callbacksMap, subChart, subChart.propertyName);
                });
                filteredPieChart.filterLabel = chart.label;
                filteredPieChart.label =
                    '(' +
                        filteredPieChart.charts
                            .map((subChart) => subChart.label)
                            .join(' / ') +
                        ') ' +
                        configuration.labels['for'] +
                        ' ' +
                        filteredPieChart.filterLabel;
                // and now adapt the labels for the sub charts
                filteredPieChart.charts.forEach((subChart) => {
                    subChart.label =
                        subChart.label + ' ' + configuration.labels['for'] + ' ' + filteredPieChart.filterLabel;
                });
            }
            else {
                enrichChart(observationType, callbacksMap, chart, chart.propertyName);
                chart.label = 'Unknown Chart Type';
            }
        });
    });
    // determine the maximum number of charts per section
    configuration.options.maxSectionChartCount = Math.max(...configuration.options.sections.map((section) => section.chartCount));
};
/**
 * helper function that enriches the basic chart definition with labels and enum
 * colors/labels values etc.
 */
const enrichChart = (observationType, callbacksMap, chart, pointer) => {
    let pointerParts = pointer.split('.');
    if (pointerParts.length > 2 && pointerParts[0] === 'callbacks') {
        let callBackDefinition = callbacksMap[pointerParts[1]];
        chart.label = pointerParts
            .slice(2)
            .reduce((value, key) => (value != null ? value[key] : undefined), callBackDefinition.labels);
        //chart.value = (dataItem: Datum) => pointerParts.slice(2).reduce((value, key) => value != null ? value[key] : undefined, dataItem.properties.callbacks && dataItem.properties.callbacks[pointerParts[1]] ? dataItem.properties.callbacks[pointerParts[1]].result : undefined);
        chart.value = (datum) => pointerParts
            .slice(2)
            .reduce((value, key) => (value != null ? value[key] : undefined), datum.callbacks && datum.callbacks[pointerParts[1]]
            ? datum.callbacks[pointerParts[1]].result
            : undefined);
        const enumDefinition = pointerParts
            .slice(2)
            .reduce((value, key) => (value != null ? value[key] : undefined), callBackDefinition.definition.enumMap);
        const values = enumDefinition.values;
        const labels = enumDefinition.labels;
        const colors = enumDefinition.colors;
        chart.map = values
            .map((value, index) => {
            return { value: value, index: index };
        })
            .reduce((map, entry) => {
            map[entry.value] = entry.index;
            return map;
        }, {});
        chart.values = values.map((value, index) => {
            return {
                value: value,
                index: index,
                className: `${pointer.replace(/\./g, '_')}_${index}`,
                label: labels ? labels[index] : '?',
                color: colors ? colors[index] : 'rgb(128,128,128)'
            };
        });
    }
    else {
        chart.label = pointerParts.reduce((value, key) => (value != null ? value[key] : undefined), observationType.schema.properties).title;
        chart.value = (datum) => {
            //let value = pointerParts.reduce((value, key) => value != null ? value[key] : undefined, <any>datum.properties);
            let value = pointerParts.reduce((value, key) => (value != null ? value[key] : undefined), datum);
            return value != null ? value.toString() : undefined;
        };
        const values = pointerParts.reduce((value, key) => (value != null ? value[key] : undefined), observationType.schema.properties).enum;
        const labels = pointerParts.reduce((value, key) => (value != null ? value[key] : undefined), observationType.keyMap).labels;
        const colors = pointerParts.reduce((value, key) => (value != null ? value[key] : undefined), observationType.keyMap).colors;
        chart.map = values
            .map((value, index) => {
            return { value: value, index: index };
        })
            .reduce((map, entry) => {
            map[entry.value] = entry.index;
            return map;
        }, {});
        chart.values = values.map((value, index) => {
            return {
                value: value,
                index: index,
                className: `${pointer.replace(/\./g, '_')}_${index}`,
                label: labels ? labels[index] : '?',
                color: colors ? colors[index] : 'rgb(128,128,128)'
            };
        });
    }
};
